import styled from 'styled-components';

import { ArrowContainerProps } from './types';

import { DirectionUp } from '../../../../assets/icons/DirectionUp';
import { DirectionDown } from '../../../../assets/icons/DirectionDown';
import { DirectionBoth } from '../../../../assets/icons/DirectionBoth';
import { DirectionLeft } from '../../../../assets/icons/DirectionLeft';
import { DirectionRight } from '../../../../assets/icons/DirectionRight';
import { Typography } from '../../../display/Typography';
import { DirectionBothVertical } from '../../../../assets/icons/DirectionBothVertical';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  /* Fix 2026-07-12 (feedback usuario, modal Nuevo tramo): la barra "Sin
     especificar" (ArrowContainerCustom, width:100%) se estiraba al ancho del
     form mientras las flechas suman ancho fijo — desproporción. Con
     fit-content la barra mide EXACTAMENTE lo que la fila de flechas, en
     todos los consumidores del componente. */
  width: fit-content;
  //gap: ${({ theme }) => theme.spacing.xxxs};
`;

export const SecondaryContainer = styled.div`
  display: flex;
`;

export const DirectionLabelsRow = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const ArrowLabel = styled.label`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xxxs};
`;

export const ArrowContainer = styled.div<ArrowContainerProps>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0.1rem solid
    ${(props) =>
      props.borderError
        ? props.theme.colors.lightCoralRed
        : props.theme.colors.black};
  cursor: pointer;
  border-radius: ${({ theme }) => theme.borderRadius.md};
  width: 5.8rem;
  height: 4rem;
  background-color: ${({ theme }) => theme.colors.white};
  ${(props) =>
    props.separated &&
    !props.lastButton && {
      marginRight: '2.5rem',
    }}
  ${(props) =>
    props.firstButton &&
    !props.separated && {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomLeftRadius: 0,
    }}
     ${(props) =>
    props.lastButton &&
    !props.separated && {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
    }}
     ${(props) =>
    !props.firstButton &&
    !props.lastButton &&
    !props.separated && {
      borderRadius: 0,
      borderLeftWidth: 0,
      borderRightWidth: 0,
    }}
  ${(props) =>
    props.firstButton &&
    !props.separated &&
    props.hasUnspecific && {
      borderBottomLeftRadius: 0,
    }}
  ${(props) =>
    props.lastButton &&
    !props.separated &&
    props.hasUnspecific && {
      borderBottomRightRadius: 0,
    }}
    ${(props) =>
    props.selectedArrow &&
    `
      background-color: ${props.theme.colors.black};
    `}
    &:focus {
    outline: 0.1rem solid ${({ theme }) => theme.colors.black};
  }
`;

export const ArrowContainerCustom = styled(ArrowContainer)`
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  width: 100%;
  text-align: center;
`;

export const Input = styled.input`
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  cursor: pointer;
  margin: 0;
`;

export const DirectionUpIcon = styled(DirectionUp)`
  pointer-events: none;
  position: relative;
  z-index: 1;

  input[type='radio']:checked ~ & {
    fill: ${({ theme }) => theme.colors.white};
  }
`;

export const DirectionDownIcon = styled(DirectionDown)`
  pointer-events: none;
  position: relative;
  z-index: 1;

  input[type='radio']:checked ~ & {
    fill: ${({ theme }) => theme.colors.white};
  }
`;

export const Text = styled(Typography)`
  pointer-events: none;
  position: relative;
  z-index: 1;
  width: 100%;
  font-size: 1.4rem;

  input[type='radio']:checked ~ & {
    color: white;
  }
`;

export const DirectionRightIcon = styled(DirectionRight)`
  pointer-events: none;
  position: relative;
  z-index: 1;

  input[type='radio']:checked ~ & {
    fill: ${({ theme }) => theme.colors.white};
  }
`;

export const DirectionLeftIcon = styled(DirectionLeft)`
  pointer-events: none;
  position: relative;
  z-index: 1;

  input[type='radio']:checked ~ & {
    fill: ${({ theme }) => theme.colors.white};
  }
`;

export const DirectionBothIcon = styled(DirectionBoth)`
  pointer-events: none;
  position: relative;
  z-index: 1;

  input[type='radio']:checked ~ & {
    fill: ${({ theme }) => theme.colors.white};
  }
`;

export const DirectionBothVerticalIcon = styled(DirectionBothVertical)`
  pointer-events: none;
  position: relative;
  z-index: 1;

  input[type='radio']:checked ~ & {
    fill: ${({ theme }) => theme.colors.white};
  }
`;

export const TextLabel = styled(Typography)``;

export const DirectionLabelText = styled(Typography)`
  font-size: 1.1rem;
  color: ${({ theme }) => theme.colors.darkGrey};
  text-align: center;
  white-space: nowrap;
  width: 5.8rem;
`;

export const DirectionLabelsContainer = styled.div`
  display: flex;
  margin-top: ${({ theme }) => theme.spacing.xxxs};
  margin-bottom: ${({ theme }) => theme.spacing.xxxs};
`;
